import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Lock } from "lucide-react";
import { LOGO, WHATSAPP } from "@/lib/api";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/sobre-mi", label: "Sobre mí" },
  { to: "/servicios", label: "Servicios" },
  { to: "/psicopedagogia-forense", label: "Forense" },
  { to: "/blog", label: "Blog" },
  { to: "/tienda", label: "Tienda" },
  { to: "/contacto", label: "Contacto" },
];

export const PublicNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className="sticky top-0 z-50 border-b border-[#dcd5ce] bg-[#f9f8f6]/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={LOGO} alt="Nilo" className="h-12 w-12 rounded-full object-cover" />
          <span className="leading-tight">
            <span className="block serif text-xl">Nilo</span>
            <span className="label-xs">Espacio Psicopedagógico</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s|í/g, "")}`}
              className={`text-sm transition-colors hover:text-[#c5a059] ${
                pathname === l.to ? "text-[#c5a059]" : "text-[#5e5a56]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/portal"
            data-testid="nav-portal"
            className="btn-gold rounded-full px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.18em]"
          >
            Portal Paciente
          </Link>
        </nav>
        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-[#dcd5ce] bg-white px-6 py-4 lg:hidden">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-2.5 text-sm">
              {l.label}
            </Link>
          ))}
          <Link to="/portal" onClick={() => setOpen(false)} className="mt-3 block btn-gold rounded-full px-5 py-2.5 text-center text-xs uppercase tracking-[0.18em]">
            Portal Paciente
          </Link>
        </div>
      )}
    </header>
  );
};

export const PublicFooter = () => (
  <footer className="border-t border-[#dcd5ce] bg-white">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
      <div>
        <img src={LOGO} alt="Nilo" className="h-20 w-20 rounded-full" />
        <p className="mt-5 serif text-2xl">Nilo Espacio Psicopedagógico</p>
        <p className="mt-1 text-sm text-[#5e5a56]">Lic. Daniela Roppel — Licenciada en Psicopedagogía</p>
      </div>
      <div className="text-sm text-[#5e5a56]">
        <p className="label-xs mb-4">Contacto</p>
        <p>Necochea, Provincia de Buenos Aires, Argentina</p>
        <p className="mt-2">licroppeldaniela@hotmail.com</p>
        <p className="mt-2">02262-484516</p>
        <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="mt-4 inline-block text-[#c5a059]">
          Escribir por WhatsApp
        </a>
      </div>
      <div className="text-sm text-[#5e5a56]">
        <p className="label-xs mb-4">Enlaces</p>
        <a href="https://www.instagram.com/niloespaciopsicopedagogico" target="_blank" rel="noreferrer" className="block hover:text-[#c5a059]">Instagram</a>
        <a href="https://www.linkedin.com/in/daniela-roppel" target="_blank" rel="noreferrer" className="mt-2 block hover:text-[#c5a059]">LinkedIn</a>
        <Link to="/tienda" className="mt-2 block hover:text-[#c5a059]">Tienda</Link>
        <Link to="/portal" className="mt-2 block hover:text-[#c5a059]">Portal Paciente</Link>
        <Link to="/acceso-administrador" data-testid="footer-admin-access" className="mt-6 flex items-center gap-2 text-xs text-[#b9b2ab] hover:text-[#c5a059]">
          <Lock size={12} /> Acceso Administrador
        </Link>
      </div>
    </div>
    <div className="border-t border-[#ebe5df] px-6 py-5 text-center text-xs text-[#8b8480]">
      © {new Date().getFullYear()} Nilo Espacio Psicopedagógico — Todos los derechos reservados
    </div>
  </footer>
);
